import React, {useEffect, useLayoutEffect, useReducer, useRef, useState} from "react";
import {Select, Switch} from 'antd';
import * as webAdSizeLib from "../aodApi/wedAdSizes";
import { pick} from 'lodash';
import { Label} from "../uiUtils/Helpers";
import {DebounceNumber} from "../uiUtils/DebouncedNumber";
import * as utils from "../lib/Utils";

export const { Option} = Select;

export function WebOutput(
    {
        onChange= ()=>{},
        onNameChange= ()=>{},
        dimensions,
        keepAspectRatio, setKeepAspectRatio,
        template
})
{
    // todo ? use reducer like PrintOutput
    const [sizeName, setSizeName] = useState('Custom');
    const widthRef = useRef(null);

    useEffect(()=> {
        //console.log('web dims changed', dimensions); //, previousDims);
        const sizeRec = webAdSizeLib.getWebAdSizeByDims(dimensions);
        setSizeName(sizeRec ? sizeRec.name : 'Custom');
    },[dimensions]);

    useEffect(()=>{
        if (sizeName==='Custom'){
            widthRef.current.focus();
            onNameChange('Custom Size');
        } else {
            //console.log('web size changed', sizeName);
            setKeepAspectRatio(false);
            onChange(pick(webAdSizeLib.getWebAdSizeByName(sizeName), 'width','height'));
            const match = sizeName.match(/\(([^)]+)\)/);
            onNameChange(match ? match[1] : sizeName);
        }

    },[sizeName]);


    // todo ? validate/parse to int number input
    return (
        <>
            <Label>Standard size</Label>
            <Select onChange={setSizeName} value={sizeName} style={{width:250}} defaultValue='Custom' size={'small'}>
                    {webAdSizeLib.webAdSizes.map((s)=>
                        <Option key={s.id} value={s.name}>{s.name}</Option>
                    )}
                </Select>
            <p/>
            <Label>Width</Label>
            <DebounceNumber  min={0} max={936}
                             size={'small'}
                             onChange={(width)=>onChange({width})} value={dimensions.width}
                             step={10} ref={widthRef} disabled={sizeName!=='Custom'}/>
            <span> (unit=pixel)</span>
            <p/>
            <Label>Depth</Label>
            <DebounceNumber min={0} max={1512}
                            size={'small'}
                            onChange={(height)=>onChange({height})} value={dimensions.height}
                            step={10}
                            disabled={sizeName!=='Custom' || keepAspectRatio}
            />
            <Switch size="small"
                    checked={keepAspectRatio}
                    onChange={setKeepAspectRatio}
                    style={{marginLeft:5}}
                    disabled={sizeName!=='Custom'}
            />
            <span> Use template proportions</span>
        </>
    );
}